import { render, staticRenderFns } from "./specsgoods.vue?vue&type=template&id=263f8ddc&scoped=true&"
import script from "./specsgoods.vue?vue&type=script&lang=js&"
export * from "./specsgoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263f8ddc",
  null
  
)

export default component.exports